// Configuration des URLs de l'API
export const API_URL = process.env.REACT_APP_API_URL ?? ''/*http://localhost:3001*/;
export const PORTAIL_URL = `${API_URL}/portail-recrutement`;
